module.exports = __webpack_public_path__ + "static/media/trainer1.1747f47c.jpg";